import React, { useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faFileExcel, faUsers } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import Layout from 'components/layout/base';
import PageTitleCard from 'components/page-title-card';
import lib from '../../../helpers/lib';
import AnaliticoMixClienteFaturamento from './analitico-mix-cliente-faturamento';
import AnaliticoMixClienteVolume from './analitico-mix-cliente-volume';
import AnaliticoMixClientePrecoMedio from './analitico-mix-cliente-preco-medio';
import PedidoService from 'services/pedido-service';
import RelatorioService from 'services/relatorio-service';
import LojaService from 'services/loja-service';

export default function AnaliticoMixCliente() {
  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();

  const [mesFiltrado, setMesFiltrado] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const [vendedores, setVendedores] = React.useState([]);
  const [regionais, setRegionais] = React.useState([]);

  const [faturamentoClientesGeral, setFaturamentoClientesGeral] = React.useState([]);

  const [loadedVendedores, setLoadedVendedores] = React.useState(false);
  const [loadedRegionais, setLoadedRegionais] = React.useState(false);

  const [filter, setFilter] = React.useState({
    codigoPedido: '',
    representadaId: null,
    vendedorId: null,
    regionalId: null,
    quantidadeClientes: 30,
    mes: m + 1,
    ano: y
  });

  const [qtdClientes, setQtdClientes] = React.useState([
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 30, label: '30' },
    { value: null, label: 'Todos' }
  ]);

  useEffect(() => {
    (async () => {
      getSelectListVendedor();
      getRegionais();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (loadedVendedores && loadedRegionais) {
        getFaturamentoMixClientesGeral();
      }
    })();
  }, [loadedVendedores, loadedRegionais]);

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();
    if (vendedores.data) {
      setVendedores(vendedores.data.data);

      if (vendedores.data.data.length == 1) {
        setFilter((prevFilter) => ({ ...prevFilter, vendedorId: vendedores.data.data[0].value }));
      }
    }
    setLoadedVendedores(true);
  }

  async function getRegionais() {
    const response = await LojaService.listRegionaisAsync();
    if (response?.data) {
      setRegionais(response?.data?.data);
    }

    setLoadedRegionais(true);
  }

  async function getFaturamentoMixClientesGeral() {
    setIsLoading(true);

    let response = await RelatorioService.getFaturamentoMixClientesGeral(filter);

    if (response?.data) {
      setFaturamentoClientesGeral(response?.data);
      setMesFiltrado(filter.mes);
    }

    setIsLoading(false);
  }

  async function getExtratoFaturamentoMixClientesGeral() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoFaturamentoMixClientesGeral(filter);

    if (response?.data) {
      let fileName = `faturamento_analitico_mix_clientes_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data, fileName);
    }

    setIsLoading(false);
  }

  return (
    <Layout>
      <PageTitleCard title="Analítico Mix Cliente" icon={<FontAwesomeIcon icon={faUsers} />} />

      <div className="background-relatorio filter-bar2 mb-5">
        <div className="row">
          <div className="col-lg-2">
            <label>Vendedor</label>
            <Select
              isClearable={vendedores?.length > 1}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={vendedores}
              value={vendedores?.find((x) => x.value === filter.vendedorId)}
              onChange={(selectedValue) => {
                selectedValue
                  ? setFilter({ ...filter, vendedorId: selectedValue?.value })
                  : setFilter({ ...filter, vendedorId: null });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Regional</label>
            <Select
              isClearable={true}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={regionais}
              getOptionLabel={(option) => option.nome}
              getOptionValue={(option) => option.regionalId}
              value={regionais?.find((x) => x.value === filter.regionalId)}
              onChange={(selectedValue) => {
                selectedValue
                  ? setFilter({ ...filter, regionalId: selectedValue?.regionalId })
                  : setFilter({ ...filter, regionalId: null });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Top Clientes</label>
            <Select
              isClearable={false}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={qtdClientes}
              value={qtdClientes?.find((x) => x.value === filter.quantidadeClientes)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, quantidadeClientes: selectedValue.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Mês</label>
            <Select
              className="select-form-control"
              value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
              options={lib.selectListMeses}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, mes: item.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Ano</label>
            <Select
              className="select-form-control"
              value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
              options={lib.selectListAnos}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, ano: item.value });
              }}
            />
          </div>

          <div className="col row">
            <div className="col align-content-end">
              {/* Botão Exportar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                  });
                  getExtratoFaturamentoMixClientesGeral();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFileExcel} /> Exportar
              </button>
            </div>
            <div className="col align-content-end">
              {/* Botão Filtrar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                    //pageNumber: 1
                  });
                  getFaturamentoMixClientesGeral();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFilter} /> Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>

      <Tabs defaultActiveKey="Faturamento" id="tabs-relatorio">
        <Tab
          eventKey="Faturamento"
          title={
            <>
              {/* <FontAwesomeIcon icon={faDollarSign} /> */}
              Faturamento
            </>
          }
        >
          <AnaliticoMixClienteFaturamento
            faturamentoClientesValores={faturamentoClientesGeral}
            mesFiltrado={mesFiltrado}
            isLoading={isLoading}
          />
        </Tab>

        <Tab
          eventKey="Volume"
          title={
            <>
              {/* <FontAwesomeIcon icon={faWeightHanging} /> */}
              Volume
            </>
          }
        >
          <AnaliticoMixClienteVolume
            faturamentoClientesVolumes={faturamentoClientesGeral}
            mesFiltrado={mesFiltrado}
            isLoading={isLoading}
          />
        </Tab>

        <Tab
          eventKey="PrecoMedio"
          title={
            <>
              {/* <FontAwesomeIcon icon={faWeightHanging} /> */}
              Preço Médio
            </>
          }
        >
          <AnaliticoMixClientePrecoMedio
            faturamentoClientesPrecosMedios={faturamentoClientesGeral}
            mesFiltrado={mesFiltrado}
            isLoading={isLoading}
          />
        </Tab>
      </Tabs>
    </Layout>
  );
}
